import { getUserDetail } from "services/user/user.session.service";
import { getActionLiteral, mapErrorNotes } from "./TripSelector.service";

export const optionsCode = {
  ARRIVE: "arriveAt",
  LEAVE: "leaveAt",
  ANYTIME: "anytime",
};

export function initialDetailLiteralsAtom(t: any) {
  return {
    eachTime: t("initialDetailLiteralsAtom.eachTime"),
    // action: 'En la estación, coge el tren', // ¿Dinámico desde el servicio?
    delete: t("initialDetailLiteralsAtom.delete"),
    walkTransbordo: t("initialDetailLiteralsAtom.walkTransbordo"),
    walkDestination: t("initialDetailLiteralsAtom.walkDestination"),
    walkCheckIn: t("initialDetailLiteralsAtom.walkCheckIn"),
    tripId: t("initialDetailLiteralsAtom.tripId"),

    /* UI-ROUTE-START-END LITERALS */
    leaveFrom: t("initialDetailLiteralsAtom.leaveFrom"),
    arrivedAt: t("initialDetailLiteralsAtom.arrivedAt"),
    /* FIN  UI-ROUTE-START-END LITERALS */

    /* UI-STOPS LITERALS*/
    seeRoute: t("initialDetailLiteralsAtom.seeRoute"),
    step: t("initialDetailLiteralsAtom.step"),
    steps: t("initialDetailLiteralsAtom.steps"),
    direct: t("initialDetailLiteralsAtom.direct"),
    durationEstimated: t("initialDetailLiteralsAtom.durationEstimated"),
    actionStart: t("initialDetailLiteralsAtom.actionStart"),
    actionEnd: t("initialDetailLiteralsAtom.actionEnd"),
    altFoldIcon: t("initialDetailLiteralsAtom.altFoldIcon"),
    altUnfoldIcon: t("initialDetailLiteralsAtom.altUnfoldIcon"),
    drivingLicense: t("initialDetailLiteralsAtom.drivingLicense"),
    toltip: t("initialDetailLiteralsAtom.toltip"),
    tariff: t("initialDetailLiteralsAtom.tariff"),
    thereIs: t("initialDetailLiteralsAtom.thereIs"),
    roadsideWarnings: t("initialDetailLiteralsAtom.roadsideWarnings"),
    comment: t("initialTarifLiterals.comment"),
    openRealTime: t("initialDetailLiteralsAtom.openRealTime"),
    /* FIN UI-STOPS LITERALS */
  };
}

export function loadingReturnTripLiterals(t: any) {
  return {
    title: t("loadingReturnTripLiterals.title"),
    subtitle: t("loadingReturnTripLiterals.subtitle"),
    description: t("loadingReturnTripLiterals.description"),
  };
}

// el componente no se espera la clave ticket usar linea 52
// export const initialTarifLiterals = {
//   title: "Elige tu transporte",
//   comment: "Añade un comentario al conductor",
//   button: "Seleccionar vehículo",
//   icons: ["passangers", "worked"],
//   ticket: {
//     titlecounter: "Añadir piezas de equipaje",
//     desccounter: "Tamaño medio",
//     icons: ["passangers", "worked"],
//   }
// };

export function initialTarifLiterals(t: any) {
  return {
    title: t("initialTarifLiterals.title"),
    comment: t("initialTarifLiterals.comment"),
    button: t("initialTarifLiterals.button"),
    titlecounter: t("initialTarifLiterals.titlecounter"),
    desccounter: t("initialTarifLiterals.desccounter"),
    icons: [
      t("initialTarifLiterals.icons.0"),
      t("initialTarifLiterals.icons.1"),
    ],
  };
}
export function initialBasicSummary() {
  return {
    tripdate: "weekday, dd month",
    triptime: "hh:mm - hh:mm",
    travellers: "n",
  };
}

export function initialAveTariffLiterals(t: any) {
  return {
    title: t("initialAveTariffLiterals.title"),
    comment: t("initialAveTariffLiterals.comment"),
    button: t("initialAveTariffLiterals.button"),
    titledropdown: t("initialAveTariffLiterals.titledropdown"),
    descdropdown: t("initialAveTariffLiterals.descdropdown"),
    bono: t("initialAveTariffLiterals.bono"),
    select_train: t("initialAveTariffLiterals.select_train"),
    edit_train: t("initialAveTariffLiterals.edit_train"),
    titleFromTo: t("initialAveTariffLiterals.titleFromTo"),
    returnButton: t("initialAveTariffLiterals.returnButton")
  };
}

export function initialFromToAlertModalLiterals(t: any) {
  return {
    title: t("initialFromToAlertModalLiterals.title"),
    description: t("initialFromToAlertModalLiterals.description"),
    buttons: [
      {
        size: 'w100',
        styleButton: 'primary',
        idButton: 'understand',
        type: 'button',
        text: t("initialFromToAlertModalLiterals.okay")
      }
    ]
  };
}

export function initialFromToAlertReturnModalLiterals(t: any) {
  return {
    title: t("initialFromToAlertReturnModalLiterals.title"),
    description: t("initialFromToAlertReturnModalLiterals.description"),
    buttons: [
      {
        size: 'w100',
        styleButton: 'primary',
        idButton: 'understand',
        type: 'button',
        text: t("initialFromToAlertReturnModalLiterals.okay")
      }
    ]
  };
}

export function initialTarifTikets(t: any) {
  return [
    {
      literals: {
        titlecounter: t("initialTarifTikets.0.literals.titlecounter"),
        desccounter: t("initialTarifTikets.0.literals.desccounter"),
        icons: [
          t("initialTarifTikets.0.literals.icons.0"),
          t("initialTarifTikets.0.literals.icons.1"),
        ],
      },
      id: t("initialTarifTikets.0.id"),
      text: t("initialTarifTikets.0.text"),
      color: t("initialTarifTikets.0.color"),
      mode: t("initialTarifTikets.0.mode"),
      price: t("initialTarifTikets.0.price"),
      numpersons: t("initialTarifTikets.0.numpersons"),
      numequipment: t("initialTarifTikets.0.numequipment"),
      numcounter: t("initialTarifTikets.0.numcounter"),
      showdropdown: t("initialTarifTikets.0.showdropdown"),
      showCounter: t("initialTarifTikets.0.showCounter"),
      selectedTrain: "",
      isTrainSelected: false
    },
    {
      literals: {
        titlecounter: t("initialTarifTikets.1.literals.titlecounter"),
        desccounter: t("initialTarifTikets.1.literals.desccounter"),
        icons: [
          t("initialTarifTikets.1.literals.icons.0"),
          t("initialTarifTikets.1.literals.icons.1"),
        ],
      },
      id: t("initialTarifTikets.1.id"),
      text: t("initialTarifTikets.1.text"),
      color: t("initialTarifTikets.1.color"),
      backgroundcolor: t("initialTarifTikets.1.color"),
      mode: t("initialTarifTikets.1.mode"),
      price: t("initialTarifTikets.1.price"),
      numpersons: t("initialTarifTikets.1.numpersons"),
      numequipment: t("initialTarifTikets.1.numequipment"),
      numcounter: t("initialTarifTikets.1.numcounter"),
      showdropdown: t("initialTarifTikets.1.showdropdown"),
      showCounter: t("initialTarifTikets.1.showCounter"),
    },
  ];
}

export function initialDriverCommentLiterals(t: any) {
  return {
    titleComments: t("initialDriverCommentLiterals.titleComments"),
    descComments: t("initialDriverCommentLiterals.descComments"),
    infoComments: [
      {
        text: t("initialDriverCommentLiterals.infoCommentsFirst"),
        bold: false
      },
      {
        text: t("initialDriverCommentLiterals.infoCommentsSecond"),
        bold: true
      },
      {
        text: t("initialDriverCommentLiterals.infoCommentsThird"),
        bold: false
      }
    ],
    maintext: t("initialDriverCommentLiterals.maintext"),
    buttonCancelar: t("initialDriverCommentLiterals.buttonCancelar"),
    buttonAddComments: t("initialDriverCommentLiterals.buttonAddComments"),
  };
}

export function initialBabyChairsLiterals(t: any) {
  return {
    titleComments: t("initialBabyChairsLiterals.titleComments"),
    descComments: [
      {
        text: t("initialBabyChairsLiterals.descCommentsFirst"),
        bold: false,
      },
      {
        text: t("initialBabyChairsLiterals.descCommentsSecond"),
        bold: true
      },
      {
        text: t("initialBabyChairsLiterals.descCommentsThird"),
        bold: false
      },
    ],
    infoComments: [
      {
        text: t("initialBabyChairsLiterals.infoCommentsFirst"),
        bold: false,
      },
      {
        text: t("initialBabyChairsLiterals.infoCommentsSecond"),
        bold: true,
      },
      {
        text: t("initialBabyChairsLiterals.infoCommentsThird"),
        bold: false,
      },
    ],
    countertext: t("initialBabyChairsLiterals.countertext"),
    counterdesc: t("initialBabyChairsLiterals.counterdesc"),
    buttonAddComments: t("initialBabyChairsLiterals.buttonAddComments"),
  };
}


export function initialuploadDocumentsLiterals(t: any) {
  return {
    title: t("initialuploadDocumentsLiterals.title"),
    desc: t("initialuploadDocumentsLiterals.desc"),
    button: t("initialuploadDocumentsLiterals.button"),
  };
}


export function initialNoContinueBoltLiterals(t: any) {
  return {
    title: t("initialNoContinueBoltLiterals.title"),
    desc: t("initialNoContinueBoltLiterals.desc"),
    button: t("initialNoContinueBoltLiterals.button"),
  };
}

export function initialAccessToAppLiterals(t: any) {
  return {
    title: t("initialAccessToAppLiterals.title"),
    desc: t("initialAccessToAppLiterals.desc"),
    cancelbutton: t("initialAccessToAppLiterals.cancelbutton"),
    okbutton: t("initialAccessToAppLiterals.okbutton"),
  };
}
export function initialAccessToAppTierLiterals(t: any) {
  return {
    title: t("initialAccessToAppTierLiterals.title"),
    desc: t("initialAccessToAppTierLiterals.desc"),
    cancelbutton: t("initialAccessToAppTierLiterals.cancelbutton"),
    okbutton: t("initialAccessToAppTierLiterals.okbutton"),
  };
}
export function initialDeletePlanificationModalLiterals(t: any) {
  return {
    title: t("initialDeletePlanificationModalLiterals.title"),
    desc: t("initialDeletePlanificationModalLiterals.desc"),
    cancelbutton: t("initialDeletePlanificationModalLiterals.cancelbutton"),
    okbutton: t("initialDeletePlanificationModalLiterals.okbutton"),
  };
}

export function initialRefreshModalLiterals(t: any) {
  return {
    title: t("initialRefreshModalLiterals.title"),
    desc: t("initialRefreshModalLiterals.desc"),
    confirmButton: t("initialRefreshModalLiterals.confirmButton"),
  };
}

export function initialAccessToAppMotoLiterals(t: any) {
  return {
    title: t("initialAccessToAppMotoLiterals.title"),
    desc: t("initialAccessToAppMotoLiterals.desc"),
    cancelbutton: t("initialAccessToAppMotoLiterals.cancelbutton"),
    okbutton: t("initialAccessToAppMotoLiterals.okbutton"),
  };
}

export function initialAccessToAppPatinenteLiterals(t: any) {
  return {
    title: t("initialAccessToAppPatinenteLiterals.title"),
    desc: t("initialAccessToAppPatinenteLiterals.desc"),
    cancelbutton: t("initialAccessToAppPatinenteLiterals.cancelbutton"),
    okbutton: t("initialAccessToAppPatinenteLiterals.okbutton"),
  };
}

export function initialDetailLiterals(t: any) {
  return {
    title: t("initialDetailLiterals.title"),
    button: t("initialDetailLiterals.button"),
    returnAveBut: t("initialDetailLiterals.returnAveBut"),
    showLess: t("initialDetailLiterals.showLess"),
    showMore: t("initialDetailLiterals.showMore"),
    tripDetail: t("initialDetailLiterals.tripDetail"),
    headerButton: {
      id: t("initialDetailLiterals.headerButton.id"),
      text: t("initialDetailLiterals.headerButton.text"),
      type: t("initialDetailLiterals.headerButton.type"),
      el: t("initialDetailLiterals.headerButton.el"),
    },
  };
}

export function plannerSubLiterals(t: any) {
  return {
    addReturnTrip: t("plannerSubLiterals.addReturnTrip"),
    submitButton: t("plannerSubLiterals.submitButton"),
    titleSection: t("plannerSubLiterals.titleSection"),
    arrive: t("plannerSubLiterals.arrive"),
    depart: t("plannerSubLiterals.depart"),
    //anyhour: "cualquier hora",//Comentado para que no se muestre en el planificado RAASWEB-402
    form: {
      origin: {
        id: t("plannerSubLiterals.form.origin.id"),
        name: t("plannerSubLiterals.form.origin.name"),
        label: t("plannerSubLiterals.form.origin.label"),
        msjError: {
          maintext: t("plannerSubLiterals.form.origin.msjError.maintext"),
        },
      },
      destination: {
        id: t("plannerSubLiterals.form.destination.id"),
        name: t("plannerSubLiterals.form.destination.name"),
        label: t("plannerSubLiterals.form.destination.label"),
        msjError: {
          maintext: t("plannerSubLiterals.form.destination.msjError.maintext"),
        },
      },
      passengers: {
        id: t("plannerSubLiterals.form.passengers.id"),
        name: t("plannerSubLiterals.form.passengers.name"),
        topPassengers: t("plannerSubLiterals.form.passengers.topPassengers"),
        counters: [
          {
            id: t("plannerSubLiterals.form.passengers.counters.0.id"),
            text: t("plannerSubLiterals.form.passengers.counters.0.text"),
            desc: t("plannerSubLiterals.form.passengers.counters.0.desc"),
            min: t("plannerSubLiterals.form.passengers.counters.0.min"),
            max: t("plannerSubLiterals.form.passengers.counters.0.max"),
            default: t("plannerSubLiterals.form.passengers.counters.0.default"),
          },
          {
            id: t("plannerSubLiterals.form.passengers.counters.1.id"),
            text: t("plannerSubLiterals.form.passengers.counters.1.text"),
            desc: t("plannerSubLiterals.form.passengers.counters.1.desc"),
            min: t("plannerSubLiterals.form.passengers.counters.1.min"),
            max: t("plannerSubLiterals.form.passengers.counters.1.max"),
            default: t("plannerSubLiterals.form.passengers.counters.1.default"),
          },
          {
            id: t("plannerSubLiterals.form.passengers.counters.2.id"),
            text: t("plannerSubLiterals.form.passengers.counters.2.text"),
            desc: t("plannerSubLiterals.form.passengers.counters.2.desc"),
            desc2: t("plannerSubLiterals.form.passengers.counters.2.desc2"),
            min: t("plannerSubLiterals.form.passengers.counters.2.min"),
            max: t("plannerSubLiterals.form.passengers.counters.2.max"),
            default: t("plannerSubLiterals.form.passengers.counters.2.default"),
          },
        ],
        literals: {
          passenger: t("plannerSubLiterals.form.passengers.literals.passenger"),
          passengers: t(
            "plannerSubLiterals.form.passengers.literals.passengers"
          ),
        },
      },
      departureDate: {
        id: t("plannerSubLiterals.form.departureDate.id"),
        name: t("plannerSubLiterals.form.departureDate.name"),
        label: t("plannerSubLiterals.form.departureDate.label"),
        type: t("plannerSubLiterals.form.departureDate.type"),
        msjError: {
          maintext: t(
            "plannerSubLiterals.form.departureDate.msjError.maintext"
          ),
        },
      },
      departureSchedule: {
        id: t("plannerSubLiterals.form.departureSchedule.id"),
        name: t("plannerSubLiterals.form.departureSchedule.name"),
        label: t("plannerSubLiterals.form.departureSchedule.label"),
        type: t("plannerSubLiterals.form.departureSchedule.type"),
        timeselector: t(
          "plannerSubLiterals.form.departureSchedule.timeselector"
        ),
        msjError: {
          maintext: t(
            "plannerSubLiterals.form.departureSchedule.msjError.maintext"
          ),
        },
        literals: {
          selector: t(
            "plannerSubLiterals.form.departureSchedule.literals.selector"
          ),
          options: [
            {
              code: optionsCode.ARRIVE,
              text: t(
                "plannerSubLiterals.form.departureSchedule.literals.options.0.text"
              ),
            },
            {
              code: optionsCode.LEAVE,
              text: t(
                "plannerSubLiterals.form.departureSchedule.literals.options.1.text"
              ),
            },
            //{ code: optionsCode.ANYTIME, text: "Cualquier hora" },//Comentado para que no se muestre en el planificado RAASWEB-402
          ],
        },
      },
      arrivalDate: {
        id: t("plannerSubLiterals.form.arrivalDate.id"),
        name: t("plannerSubLiterals.form.arrivalDate.name"),
        label: t("plannerSubLiterals.form.arrivalDate.label"),
        type: t("plannerSubLiterals.form.arrivalDate.type"),
        msjError: {
          maintext: t("plannerSubLiterals.form.arrivalDate.msjError.maintext"),
        },
      },
      arrivalSchedule: {
        id: t("plannerSubLiterals.form.arrivalSchedule.id"),
        name: t("plannerSubLiterals.form.arrivalSchedule.name"),
        label: t("plannerSubLiterals.form.arrivalSchedule.label"),
        type: t("plannerSubLiterals.form.arrivalSchedule.type"),
        timeselector: t("plannerSubLiterals.form.arrivalSchedule.timeselector"),
        msjError: {
          maintext: t(
            "plannerSubLiterals.form.arrivalSchedule.msjError.maintext"
          ),
        },
        literals: {
          selector: t(
            "plannerSubLiterals.form.arrivalSchedule.literals.selector"
          ),
          options: [
            {
              code: optionsCode.ARRIVE,
              text: t(
                "plannerSubLiterals.form.arrivalSchedule.literals.options.0.text"
              ),
            },
            {
              code: optionsCode.LEAVE,
              text: t(
                "plannerSubLiterals.form.arrivalSchedule.literals.options.1.text"
              ),
            },
            //{ code: optionsCode.ANYTIME, text: "Cualquier hora" },//Comentado para que no se muestre en el planificado RAASWEB-402
          ],
        },
      },
    },
  };
}

export function getTransportFilterLiterals(t: any, data?: any) {
  return {
    title: t("getTransportFilterLiterals.title"),
    title2: t("getTransportFilterLiterals.title2"),
    buttoncard: [
      {
        id: t("getTransportFilterLiterals.buttoncard.0.id"),
        icon: t("getTransportFilterLiterals.buttoncard.0.icon"),
        text: t("getTransportFilterLiterals.buttoncard.0.text"),
        selected: data ? data?.buttoncard[0]?.selected : false,
      },
      {
        id: t("getTransportFilterLiterals.buttoncard.1.id"),
        icon: t("getTransportFilterLiterals.buttoncard.1.icon"),
        text: t("getTransportFilterLiterals.buttoncard.1.text"),
        selected: data ? data?.buttoncard[1]?.selected : false,
      },
    ],
    buttondesc: t("getTransportFilterLiterals.buttondesc"),
    title3: t("getTransportFilterLiterals.title3"),
    subtitle3: t("getTransportFilterLiterals.subtitle3"),
    transportcard: [
      {
        backId: t("getTransportFilterLiterals.transportcard.0.backId"),
        id: t("getTransportFilterLiterals.transportcard.0.id"),
        icon: t("getTransportFilterLiterals.transportcard.0.icon"),
        text: t("getTransportFilterLiterals.transportcard.0.text"),
        selected: data ? data?.transportcard[0]?.selected : true,
      },
      {
        backId: t("getTransportFilterLiterals.transportcard.1.backId"),
        id: t("getTransportFilterLiterals.transportcard.1.id"),
        icon: t("getTransportFilterLiterals.transportcard.1.icon"),
        text: t("getTransportFilterLiterals.transportcard.1.text"),
        selected: data ? data?.transportcard[1]?.selected : true,
      },
      {
        backId: t("getTransportFilterLiterals.transportcard.2.backId"),
        id: t("getTransportFilterLiterals.transportcard.2.id"),
        icon: t("getTransportFilterLiterals.transportcard.2.icon"),
        text: t("getTransportFilterLiterals.transportcard.2.text"),
        selected: data ? data?.transportcard[2]?.selected : true,
      },
      // {
      //   backId: t("getTransportFilterLiterals.transportcard.3.backId"),
      //   id: t("getTransportFilterLiterals.transportcard.3.id"),
      //   icon: t("getTransportFilterLiterals.transportcard.3.icon"),
      //   text: t("getTransportFilterLiterals.transportcard.3.text"),
      //   selected: data ? data?.transportcard[3]?.selected : true,
      // },
      {
        backId: t("getTransportFilterLiterals.transportcard.4.backId"),
        id: t("getTransportFilterLiterals.transportcard.4.id"),
        icon: t("getTransportFilterLiterals.transportcard.4.icon"),
        text: t("getTransportFilterLiterals.transportcard.4.text"),
        selected: data ? data?.transportcard[4]?.selected : true,
      }
    ],
    transportSummary: t("getTransportFilterLiterals.transportSummary"),
    errormsj: t("getTransportFilterLiterals.errormsj"),
    button: t("getTransportFilterLiterals.button"),
  };
}

export function getFilterPreferencesLiterals(t: any, data?: any) {
  return {
    title: t("getFilterPreferencesLiterals.title"),
    title2: t("getFilterPreferencesLiterals.title2"),
    button: t("getFilterPreferencesLiterals.button"),
    buttoncard: [
      {
        id: 0,
        text: t("getFilterPreferencesLiterals.buttoncard.0.text"),
      },
      {
        id: 1,
        text: t("getFilterPreferencesLiterals.buttoncard.1.text"),
      },
      {
        id: 2,
        text: t("getFilterPreferencesLiterals.buttoncard.2.text"),
      },
      {
        id: 3,
        text: t("getFilterPreferencesLiterals.buttoncard.3.text"),
      },
    ],
  }
}

export const getResumePath = (
  departureAveSection: any,
  returnAveSection: any
): string => {
  return departureAveSection?.isAveSelected || returnAveSection?.isAveSelected
    ? "/ave-stepper-page"
    : "/resume-route";
};

export const checkEmptyObject = (obj: object = {}) => {
  return (
    obj &&
    Object.keys(obj).length === 0 &&
    Object.getPrototypeOf(obj) === Object.prototype
  );
};

export const plannigObjectMock = {
  origin: {
    value: {
      timezoneOffset: 120,
      id: "A=1@O=Numància - Av Roma@X=2141347@Y=41381213@U=80@L=500004589@B=1@p=1656401661@",
      extId: "500004589",
      name: "Numància - Av Roma",
      lon: 2.141347,
      lat: 41.381213,
      weight: 12532,
      products: 320,
    },
    invalid: false,
  },
  destination: {
    value: {
      timezoneOffset: 120,
      id: "A=1@O=Milagro@X=-1765661@Y=42241705@U=80@L=600001397@B=1@p=1656401661@",
      extId: "600001397",
      name: "Milagro",
      lon: -1.765661,
      lat: 42.241705,
      weight: 347,
      products: 256,
    },
    invalid: false,
  },
  passengers: {
    value: {
      "more-than-13-counter": 1,
      "less-than-13-counter": 0,
      "less-than-3-counter": 0,
    },
    invalid: false,
  },
  departureDate: {
    value: "2022-07-08T20:00:00.000Z",
    invalid: false,
  },
  departureSchedule: {
    value: {
      hours: "11",
      minutes: "25",
      searchForArrival: "0",
    },
    invalid: false,
  },
  arrivalDate: {
    value: "2022-08-09T20:00:00.000Z",
    invalid: false,
  },
  arrivalSchedule: {
    value: {
      hours: "13",
      minutes: "45",
      searchForArrival: "1",
    },
    invalid: false,
  },
  return: false,
};

export function ModalRightLiterals(t: any) {
  return {
    title: t("ModalRightLiterals.title"),
    title2: t("ModalRightLiterals.title2"),
    buttonCard: [
      {
        id: t("ModalRightLiterals.buttonCard.0.id"),
        icon: t("ModalRightLiterals.buttonCard.0.icon"),
        text: t("ModalRightLiterals.buttonCard.0.text"),
      },
      {
        id: t("ModalRightLiterals.buttonCard.1.id"),
        icon: t("ModalRightLiterals.buttonCard.1.icon"),
        text: t("ModalRightLiterals.buttonCard.1.text"),
      },
    ],
    buttondesc: t("ModalRightLiterals.buttondesc"),
    title3: t("ModalRightLiterals.title3"),
    subtitle3: t("ModalRightLiterals.subtitle3"),
    transportCard: [
      {
        id: t("ModalRightLiterals.transportCard.0.id"),
        icon: t("ModalRightLiterals.transportCard.0.icon"),
        text: t("ModalRightLiterals.transportCard.0.text"),
        selected: t("ModalRightLiterals.transportCard.0.selected"),
      },
      {
        id: t("ModalRightLiterals.transportCard.1.id"),
        icon: t("ModalRightLiterals.transportCard.1.icon"),
        text: t("ModalRightLiterals.transportCard.1.text"),
        selected: t("ModalRightLiterals.transportCard.1.selected"),
      },
      {
        id: t("ModalRightLiterals.transportCard.2.id"),
        icon: t("ModalRightLiterals.transportCard.2.icon"),
        text: t("ModalRightLiterals.transportCard.2.text"),
        selected: t("ModalRightLiterals.transportCard.2.selected"),
      },
      {
        id: t("ModalRightLiterals.transportCard.3.id"),
        icon: t("ModalRightLiterals.transportCard.3.icon"),
        text: t("ModalRightLiterals.transportCard.3.text"),
        selected: t("ModalRightLiterals.transportCard.3.selected"),
      },
      {
        id: t("ModalRightLiterals.transportCard.4.id"),
        icon: t("ModalRightLiterals.transportCard.4.icon"),
        text: t("ModalRightLiterals.transportCard.4.text"),
        shorttime: t("ModalRightLiterals.transportCard.4.shorttime"),
        selected: t("ModalRightLiterals.transportCard.4.selected"),
      },
      {
        id: t("ModalRightLiterals.transportCard.5.id"),
        icon: t("ModalRightLiterals.transportCard.5.icon"),
        text: t("ModalRightLiterals.transportCard.5.text"),
        shorttime: t("ModalRightLiterals.transportCard.5.shorttime"),
        selected: t("ModalRightLiterals.transportCard.5.selected"),
      },
    ],
    transportSummary: t("ModalRightLiterals.transportSummary"),
    errormsj: t("ModalRightLiterals.errormsj"),
    button: t("ModalRightLiterals.button"),
  };
}

export function getNoResultLiterals(t: any) {
  return {
    title: t("getNoResultLiterals.title"),
    item1: t("getNoResultLiterals.item1"),
  };
}
export function getNoResultTrainArrivalLiterals(t: any) {
  return {
    title: t("getNoResultTrainArrivalLiterals.title"),
    item1: t("getNoResultTrainArrivalLiterals.item1"),
  };
}
export function getNoResultDateTripLiterals(t: any) {
  // TODO: literales
  return {
    title: t("getNoResultDateTripLiterals.title"),
    item1: t("getNoResultDateTripLiterals.item1"),
  };
}
export function getFooterLiterals(t: any) {
  return {
    title: t("getFooterLiterals.title"),
    showPrivacyPolicyText: t("getFooterLiterals.showPrivacyPolicyText"),
    showLegalConditionsText: t("getFooterLiterals.showLegalConditionsText"),
    showCookiePolicyText: t("getFooterLiterals.showCookiePolicyText"),
    linkPrivacyPolicyText: "https://www.docomobility.com/es/privacidad",
    linkLegalConditionsText:
      "https://www.docomobility.com/es/terminos-y-condiciones",
    linkCookiePolicyText: "https://www.docomobility.com/es/politica-de-cookies",
  };
}

export function getLeafClass(rating: number): string {
  let className = "icon-variant-5";
  switch (rating) {
    case 1:
      className = "color-ecologic-red";
      break;
    case 2:
      className = "color-ecologic-brown";
      break;
    case 3:
      className = "color-ecologic-green";
      break;
    default:
      className = "icon-variant-5";
      break;
  }
  return className;
}

const DEFAULT_COLOR = "#FFFFFF";

const ICON_COLORS: Record<string, string> = {
  ave: "#9A337E",
  busLD: "#005DB9",
  busUrb: "#005DB9",
  cercanias: "#D90209",
  metro: "#02770A",
  moto: "#0172F0",
  patinete: "#0E1A50",
  Freenow: "#B4282E",
  BOLT: "#2D8659",
  KARHOO: "#E80868",
  MOVITAXI: "#668D34",
  COCHE: "#DF6C01",
};

const BICI_COLORS: Record<string, string> = {
  "Donkey": "#FF6600",
  "Donkey Republic": "#FF6600",
  Lyft: "#FF00BF",
  "Nextbike":"#0E4BCF",
  "jcdecaux":"#063494"
};

export function getTransportColor(
  icon: string,
  transportTypeString: string
): string {
  if (icon === "bici") {
    return (
      BICI_COLORS[transportTypeString] ||
      "#326ACE"
    );
  }

  return ICON_COLORS[icon] || DEFAULT_COLOR;
}


export function LoginModalLiterals(t: any) {
  return {
    /*welcomeBackMsg: t("LoginModalLiterals.welcomeBackMsg"),*/
    title: t("LoginModalLiterals.title"),
    description: t("LoginModalLiterals.description"),
    message: { maintext: t("LoginModalLiterals.message.maintext") },
    emailInput: { maintext: t("LoginModalLiterals.emailInput.maintext") },
    passwordInput: {
      maintext: { maintext: t("LoginModalLiterals.passwordInput.maintext") },
    },
    recoverButtonText: t("LoginModalLiterals.recoverButtonText"),
    loginButtonText: t("LoginModalLiterals.loginButtonText"),
    noAccountAsk: t("LoginModalLiterals.noAccountAsk"),
    createAccountButtonText: t("LoginModalLiterals.createAccountButtonText"),
  };
}

export const ReactPathNavigation = {
  recoverPasswordFlow: "/reset-password",
  registerUserFlow: "/register-user",
};

export function ConfirmModalLiterals(t: any) {
  return {
    title: t("ConfirmModalLiterals.title"),
    descriptionPartOne: t("ConfirmModalLiterals.descriptionPartOne"),
    descriptionPartTwo: t("ConfirmModalLiterals.descriptionPartTwo"),
    codeTitle: t("ConfirmModalLiterals.codeTitle"),
    resendEmailPartOne: t("ConfirmModalLiterals.resendEmailPartOne"),
    resendEmailPartTwo: t("ConfirmModalLiterals.resendEmailPartTwo"),
    emailButtonText: {
      openYourMail: t("ConfirmModalLiterals.emailButtonText.openYourMail"),
      verifyYourAccount: t(
        "ConfirmModalLiterals.emailButtonText.verifyYourAccount"
      ),
    },
  };
}

export const RenfeTrainCodesList = [
  "ALVIA",
  "AVE",
  "AVLO",
  "AVANT",
  "INTERCITY",
  "REGIONAL",
  "REG.EXP.",
  "MD",
  "AVE-TGV",
  "EUROMED",
  "Intercit",
  "TORRE OR",
  "RENAVANT",
  "REN AVE",
  "REN MD",
  "AVE INT",
  "CHARTER"
];

export function PersonalDataModalLiterals(t: any) {
  return {
    title: t("PersonalDataModalLiterals.title"),
    description: t("PersonalDataModalLiterals.description"),
    cancelButtonText: t("PersonalDataModalLiterals.cancelButtonText"),
    goToProfileButtonText: t("PersonalDataModalLiterals.goToProfileButtonText"),
  };
}

export function getRouteBoxLiterals(t: any) {
  return {
    moreText: t("routeBoxLiterals.moreText"),
    updateText: t("routeBoxLiterals.updateText"),
    externalBuy: t("routeBoxLiterals.externalBuy"),
    moreEco: t("routeBoxLiterals.moreEco"),
    thereIs: t("routeBoxLiterals.thereIs"),
    roadsideWarnings: t("routeBoxLiterals.roadsideWarnings"),
  };
}



/* RAASWEB-840 Sección para modificar la hora actual sin lanzar toast cada minuto */
export function modifyBodyCurrentDate(body: any) {
  const curr = new Date();
  const copy = { ...body };

  copy.departureSchedule.value = {
    ...copy.departureSchedule.value,
    hours: addZerosLeft(curr.getHours()),
    minutes: addZerosLeft(curr.getMinutes()),
  };
  return copy;
}

export function addZerosLeft(n: any) {
  n = n + "";
  return n.length >= 2 ? n : new Array(2 - n.length + 1).join("0") + n;
}

export function checkISCurrentDate(body: any) {
  const todayDate = new Date();
  const departureDate = new Date(body?.departureDate?.value);
  const sameDate = todayDate.getDate() === departureDate.getDate();
  const sameMonth = todayDate.getMonth() === departureDate.getMonth();
  const sameYear = todayDate.getFullYear() === departureDate.getFullYear();
  return sameDate && sameMonth && sameYear;
}

export function checkDiffTimeFromCurrent(body: any) {
  const departure = body.departureSchedule.value;
  const curr: any = new Date();
  const bodyDate: any = new Date(
    curr.getFullYear(),
    curr.getMonth(),
    curr.getDate(),
    departure.hours,
    departure.minutes
  );
  const diff = convertToHours(curr - bodyDate);
  if (diff < 2) {
    // menos de una hora
    return true;
  } else {
    return false;
  }
}

export function convertToHours(milisec: number) {
  return milisec / 1000 / 60 / 60;
}
/* FIN RAASWEB-840 */

export function getFilterTravelPreference() {
  let result = "",
    valueUserDetail = getUserDetail();
  let filter = valueUserDetail?.preferences?.optimalRoutes.find(
    (el: any) => el.enabled === true
  );
  if (filter) {
    switch (filter.type) {

      case "DIRECT":
        result = "0";
        break;
      case "FAST":
        result = "1";
        break;

      case "ECONOMIC":
        result = "0";
        break;

      case "SUSTAINABLE":
        result = "3";
        break;
      default:
        break;
    }
  } else {
    result = "2";
  }
  return result;
}

export const fromToTickets = [
  {
    fromToSelected: true,
    fromToID: "A",
    tripOptions: {
      departureTime: "17:05 - 20:06",
      totalTime: "3 h 1 min",
      tripDayPlanified: true,
      price: "16,50 € ",
      ecologicSection: [
        {
          icon: "leafFull",
          size: "24px",
          iconFill: "color-ecologic-green",
        },
        {
          icon: "leafFull",
          size: "24px",
          iconFill: "color-ecologic-green",
        },
        {
          icon: "leafFull",
          size: "24px",
          iconFill: "color-ecologic-green",
        },
      ],
      trasportSection: [
        {
          icon: "ave",
          transportTypeString: "AVE Larga distancia",
          text: "AVANT",
          size: "24px",
          backgroundcolor: "#9A337E",
          idx: 0,
        },
      ],
      hideDetail: false,
      hasExternalBuy: true,
    },
    literals: {
      moreText: "màs",
      updateText: "Actualizar precio",
      externalBuy: "Compra externa",
    },
    isFromTo: true,
  },
  {
    fromToSelected: false,
    fromToID: "B",
    tripOptions: {
      departureTime: "17:05 - 20:06",
      totalTime: "3 h 1 min",
      tripDayPlanified: true,
      price: "16,50 € ",
      ecologicSection: [
        {
          icon: "leafFull",
          size: "24px",
          iconFill: "color-ecologic-green",
        },
        {
          icon: "leafFull",
          size: "24px",
          iconFill: "color-ecologic-green",
        },
        {
          icon: "leafFull",
          size: "24px",
          iconFill: "color-ecologic-green",
        },
      ],
      trasportSection: [
        {
          icon: "ave",
          transportTypeString: "AVE Larga distancia",
          text: "AVANT",
          size: "24px",
          background: "#9A337E",
          idx: 0,
        },
      ],
      hideDetail: false,
      hasExternalBuy: true,
    },
    literals: {
      moreText: "màs",
      updateText: "Actualizar precio",
      externalBuy: "Compra externa",
    },
    isFromTo: true,
  },
  {
    fromToSelected: false,
    fromToID: "C",
    tripOptions: {
      departureTime: "17:05 - 20:06",
      totalTime: "3 h 1 min",
      tripDayPlanified: true,
      price: "16,50 € ",
      ecologicSection: [
        {
          icon: "leafFull",
          size: "24px",
          iconFill: "color-ecologic-green",
        },
        {
          icon: "leafFull",
          size: "24px",
          iconFill: "color-ecologic-green",
        },
        {
          icon: "leafFull",
          size: "24px",
          iconFill: "color-ecologic-green",
        },
      ],
      trasportSection: [
        {
          icon: "ave",
          transportTypeString: "AVE Larga distancia",
          text: "AVANT",
          size: "24px",
          background: "#9A337E",
          idx: 0,
        },
      ],
      hideDetail: false,
      hasExternalBuy: true,
    },
    literals: {
      moreText: "màs",
      updateText: "Actualizar precio",
      externalBuy: "Compra externa",
    },
    isFromTo: true,
  },
  {
    fromToSelected: false,
    fromToID: "D",
    tripOptions: {
      departureTime: "17:05 - 20:06",
      totalTime: "3 h 1 min",
      tripDayPlanified: true,
      price: "16,50 € ",
      ecologicSection: [
        {
          icon: "leafFull",
          size: "24px",
          iconFill: "color-ecologic-green",
        },
        {
          icon: "leafFull",
          size: "24px",
          iconFill: "color-ecologic-green",
        },
        {
          icon: "leafFull",
          size: "24px",
          iconFill: "color-ecologic-green",
        },
      ],
      trasportSection: [
        {
          icon: "ave",
          transportTypeString: "AVE Larga distancia",
          text: "AVANT",
          size: "24px",
          background: "#9A337E",
          idx: 0,
        },
      ],
      hideDetail: false,
      hasExternalBuy: true,
    },
    literals: {
      moreText: "màs",
      updateText: "Actualizar precio",
      externalBuy: "Compra externa",
    },
    isFromTo: true,
  },
  {
    fromToSelected: false,
    fromToID: "E",
    tripOptions: {
      departureTime: "17:05 - 20:06",
      totalTime: "3 h 1 min",
      tripDayPlanified: true,
      price: "16,50 € ",
      ecologicSection: [
        {
          icon: "leafFull",
          size: "24px",
          iconFill: "color-ecologic-green",
        },
        {
          icon: "leafFull",
          size: "24px",
          iconFill: "color-ecologic-green",
        },
        {
          icon: "leafFull",
          size: "24px",
          iconFill: "color-ecologic-green",
        },
      ],
      trasportSection: [
        {
          icon: "ave",
          transportTypeString: "AVE Larga distancia",
          text: "AVANT",
          size: "24px",
          background: "#9A337E",
          idx: 0,
        },
      ],
      hideDetail: false,
      hasExternalBuy: true,
    },
    literals: {
      moreText: "màs",
      updateText: "Actualizar precio",
      externalBuy: "Compra externa",
    },
    isFromTo: true,
  },
  {
    fromToSelected: false,
    fromToID: "F",
    tripOptions: {
      departureTime: "17:05 - 20:06",
      totalTime: "3 h 1 min",
      tripDayPlanified: true,
      price: "16,50 € ",
      ecologicSection: [
        {
          icon: "leafFull",
          size: "24px",
          iconFill: "color-ecologic-green",
        },
        {
          icon: "leafFull",
          size: "24px",
          iconFill: "color-ecologic-green",
        },
        {
          icon: "leafFull",
          size: "24px",
          iconFill: "color-ecologic-green",
        },
      ],
      trasportSection: [
        {
          icon: "ave",
          transportTypeString: "AVE Larga distancia",
          text: "AVANT",
          size: "24px",
          background: "#9A337E",
          idx: 0,
        },
      ],
      hideDetail: false,
      hasExternalBuy: true,
    },
    literals: {
      moreText: "màs",
      updateText: "Actualizar precio",
      externalBuy: "Compra externa",
    },
    isFromTo: true,
  },
];

export function calcFrecuency(minutos: number) {
  const text = `${(minutos / 60 >= 1 ? Math.floor(minutos / 60) + ' h' : '')} ${minutos % 60 != 0 ? (minutos % 60).toString().replace('.', ',') + ' min' : ''}`;
  return text;
}

/**
 * Funcion para cuando borramos un pst si contiene ave y si esta completo
 * @param trip 
 * @returns 
 */
export function checkCompleteTrainsWhenDeleting(trip: any) {
  //LegList?.Leg?
  let isFullTrain = false;
  trip?.forEach((leg: any) => {
    if (leg.icon === "ave") {
      const infoNote = mapErrorNotes(leg?.trip?.Notes);
      if (Array.isArray(infoNote)) {
        if (infoNote.find(n => n == 'full-train')) {
          isFullTrain = true;
        }

      } else if (leg.realPriceTag.price === 0) {
        isFullTrain = true;
      }

    }

  })
  return isFullTrain
}

export function checkCompleteTrains(trip: any) {
  //LegList?.Leg?
  let isFullTrain = false;
  trip?.forEach((leg: any) => {

    const infoNote = mapErrorNotes(leg?.Notes);
    if (Array.isArray(infoNote)) {
      if (infoNote.find(n => n == 'full-train')) {
        isFullTrain = true;
      }

    }



  })
  return isFullTrain
}



export function funcionBorrarCard(listCard: any, numeroPasajeros: any) {
  const data = [] as any
  listCard.forEach((element: any) => {
    if (element.showPst === true) {
      data.push(element)
    }
  });
  return data
}

export function getDisclaimerPrices(freeTransport: Boolean, externalPurchase: Boolean, t: any) {
  let result = ''

  if (freeTransport === true && externalPurchase === false) {
    //literal  no incluidos en el precio
    result = t("initialDetailLiteralsAtom.disclaimerNoPrice")
  } else if (freeTransport === false && externalPurchase === true) {
    //Esta ruta incluye compras fuera de Doco
    //result=t("initialDetailLiteralsAtom.disclaimerPriceExternal")
    result = t("initialDetailLiteralsAtom.disclaimerNoPrice")
  } else if (freeTransport === true && externalPurchase === true) {
    //literal  no incluidos en el precio
    //result=t("initialDetailLiteralsAtom.disclaimerNoPrice")
    result = t("initialDetailLiteralsAtom.disclaimerPriceExternal")
  }
  else {
    result = ''
  }
  return result
}


export function eliminarObjetosTier(data: any) {

  return data.filter((trip: any) => {
    // Verificamos si hay algún "Leg" en "LegList" cuyo "name" sea "TIER"
    const hasTierLeg = trip.LegList.Leg.some((leg: any) => leg.name === "TIER");
    // Si no hay un "Leg" con "name" igual a "TIER", mantenemos el objeto


    return !hasTierLeg;
  });
};

export function elimiarNoAsientoDisponibles(data: any, travellerNumber: number) {
  return data.filter((trip: any) => {
    // Verificar si existe TariffResult y fareSetItem
    const fareSetItems = trip?.TariffResult?.fareSetItem || [];

    // Buscar si alguno de los tickets cumple con la condición
    if (fareSetItems.length !== 0 && fareSetItems[0].name === "Bolt Pricing") {


      const tieneAsientosDisponibles = fareSetItems.some((fareSetItem: any) => {
        const fareItems = fareSetItem?.fareItem || [];

        return fareItems.some((fareItem: any) => {
          const tickets = fareItem?.ticket || [];

          return tickets.some((ticket: any) => {
            // Buscar el parámetro AVAILABLE_SEATS
            const availableSeatObject = ticket?.param?.find(
              (param: any) => param?.name === "AVAILABLE_SEATS"
            );

            // Verificar si cumple la condición
            if (availableSeatObject) {
              const availableSeats = parseInt(availableSeatObject.value, 10);
              return availableSeats >= travellerNumber;
            }

            return false;
          });
        });
      });

      // Retornar true si tiene asientos disponibles, false para eliminar el objeto
      return tieneAsientosDisponibles;
    } else {
      return trip;
    }
  });
}


// Función para convertir fromLegId y toLegId a números
export function convertLegIdsToNumbers(data: any) {
  if (!isNaN(data)) {
    return data
  } else if (data === undefined) {
    return data
  }
  else {
    return parseInt(data.split(':')[1], 10);
  }

}


export function pstLiteralsDetail(typePst: any, t: any) {
  let result

  switch (typePst?.name) {
    case 'cooltra':
      result = {
        actionStart: t("literals.findMotorcycleNearby"),
        actionEnd: t("literals.parkNear")
      }
      break;
    case 'Lyft':
    case 'BiciMAD':
    case 'Bicicleta':
    case 'Donkey Republic Spain':
      result = {
        actionStart: t("literals.findBikeNearby"),
        actionEnd: t("literals.parkNear")
      }

      break;
    default:
      result = getActionLiteral(typePst, t)
      break;
  }
  return result

}


/**
 * Comprueba si todos los elementos del array son 'child' según el pricetag seleccionado.
 * @param {Array} trips - Array de objetos (cada objeto contiene pricetag y listas de tarifas)
 * @returns {boolean} - true si todos los elementos son 'child', false en caso contrario
 */
export function isAllChildBolt(trips: any) {
  if (!Array.isArray(trips) || trips.length === 0) return false;

  return trips.every(trip => {
    // id de la tarifa seleccionada
    const selectedId = trip?.pricetag?.id;
    if (!selectedId) return false;

    // Buscar en 'tarifs' primero y si no está, en 'allTarifsList'
    const allTariffs = [
      ...(Array.isArray(trip.tarifs) ? trip.tarifs : []),
    ];

    const matched = allTariffs.find(t => t?.id === selectedId);
    if (!matched) return false;

    // Comprobación case-insensitive por si viene 'Child' u otras variantes
    const desc = (matched.desc || '').toString().toLowerCase();
    return desc === 'child_seat';
  });
}


export function childBoltModalLiterals(t: any) {
  return {
    title: t("childBoltModalLiterals.title"),
    desc: t("childBoltModalLiterals.desc"),
    cancelbutton: t("childBoltModalLiterals.cancelbutton"),
    okbutton: t("childBoltModalLiterals.okbutton"),
  };
}


/**
 * Método para impedir la compra a partir del 01/09/2026
 * Devuelve true si NO puede comprar
 */
export const canNotBuyTrip = (tripSearchDate: string | Date): boolean => {
  const tripDate = new Date(tripSearchDate);
  const limitDate = new Date("2026-09-01T00:00:00");

  return tripDate >= limitDate;
};
